// @flow

import {
  FILTERS_BRANCH,
  FILTER_STATUS,
  FILTER_ASSIGN_TO,
  FILTER_END_DATE,
  FILTER_START_DATE,
  FILTER_SEASON,
} from './../constants'

// Actions
import {
  FILTER_BY_ASSIGN_TO,
  FILTER_BY_STATUS,
  FILTER_BY_DATE_RANGE,
  FILTER_BY_SEASON,
} from 'hfty-soil-jobs/src/constants'

export default {
  [FILTER_BY_STATUS]: function<S> (state: S, payload: string): S {
    return {
      ...state,
      [FILTERS_BRANCH]: {
        ...state[FILTERS_BRANCH],
        [FILTER_STATUS]: payload,
      },
    }
  },
  [FILTER_BY_DATE_RANGE]: function<S> (state: S, {startDate, endDate}: Object): S {
    return {
      ...state,
      [FILTERS_BRANCH]: {
        ...state[FILTERS_BRANCH],
        [FILTER_START_DATE]: startDate,
        [FILTER_END_DATE]: endDate,
      },
    }
  },
  [FILTER_BY_ASSIGN_TO]: function<S> (state: S, payload: number): S {
    return {
      ...state,
      [FILTERS_BRANCH]: {
        ...state[FILTERS_BRANCH],
        [FILTER_ASSIGN_TO]: payload,
      },
    }
  },
  [FILTER_BY_SEASON]: function<S> (state: S, payload: number): S {
    return {
      ...state,
      [FILTERS_BRANCH]: {
        ...state[FILTERS_BRANCH],
        [FILTER_SEASON]: payload,
      },
    }
  },
}
